import { withTranslatedMeta } from 'i18n/utils'
import { SEARCH_MODE_PREPAID } from 'search/constants'
import { parkingModeSelector } from '@booking/selectors'
import Icon from '@components/Icon'
import Button from '@components/Button'
import { AppStoreBadge, GooglePlayStoreBadge } from '@components/AppDownloadBadge'
import { parkingPassUrlSelector, parkingPassRequirementsSelector } from '../selectors'

import '../styles/styles.scss'

const ParkingPassUrl = ({ parkingPassUrl }) => (
    <Button
        size="large"
        btnStyle="outline"
        target={parkingPassUrl ? '_blank' : undefined}
        external={!!parkingPassUrl}
        block
        href={parkingPassUrl || '/dashboard/transactions'}
        className="mb-3">
        <T>confirmation.btn.parking.pass.label</T>
    </Button>
)

const DashboardLink = () => (
    <Button size="large" href="/dashboard" block className="mb-3">
        <T>confirmation.btn.dashboard.label</T>
    </Button>
)

const ConfirmationView = ({ parkingPassUrl, parkingPassRequirements, parkingMode }) => (
    <div className="confirmation container text-center my-5">
        <div className="row row justify-content-center">
            <div className="col-md-5">
                <Icon type="success" size="xxxl" className="mb-4" />
                <h2 className="mb-5">
                    <T>confirmation.confirm.1</T>
                </h2>
                <p className="mb-5">
                    <strong>
                        {parkingMode === SEARCH_MODE_PREPAID ? (
                            <T>confirmation.confirm.prepaid</T>
                        ) : (
                            <T>confirmation.confirm.2</T>
                        )}
                    </strong>
                </p>
                {parkingPassRequirements && (
                    <div className="mb-5">
                        <div dangerouslySetInnerHTML={{ __html: parkingPassRequirements }} />
                    </div>
                )}
            </div>
        </div>
        <div className="row justify-content-center">
            {parkingPassUrl && (
                <div className="col-md-3 ">
                    <ParkingPassUrl parkingPassUrl={parkingPassUrl} />
                </div>
            )}
            <div className="col-md-3 ">
                <DashboardLink />
            </div>
        </div>
        <div className="row justify-content-center confirmation__badge-container">
            <div className="col-md-4 mt-4">
                <strong>
                    <T>confirmation.download</T>
                </strong>
                <div className="d-flex justify-content-center mt-4">
                    <AppStoreBadge imgClass="confirmation__badge" />
                    <GooglePlayStoreBadge imgClass="confirmation__badge" />
                </div>
            </div>
        </div>
    </div>
)

export default compose(
    withTranslatedMeta('confirmation.title'),
    connect(
        createStructuredSelector({
            parkingMode: parkingModeSelector,
            parkingPassUrl: parkingPassUrlSelector,
            parkingPassRequirements: parkingPassRequirementsSelector,
        })
    )
)(ConfirmationView)
